import gql from 'graphql-tag';

export const GET_QUESTIONNAIRES_QUERY = gql`
  query getQuestionnaire($name: String, $typeCode: Int) {
    questionnaires(name: $name, typeCode: $typeCode) {
      id
      questions {
        id
        name
        definitions
        inputType
        inputTypeOptionSet
        inputValue
        qualification
        questionSet
        questionOrder
        questionSentence
        questionErrorMessage
        questionHelpMessage
        autoPopulateDwellingType
        statusCode
      }
    }
  }
`;
